module.exports = __webpack_public_path__ + "img/ep-alphabet.68cc2405.jpg";